module.exports = __webpack_public_path__ + "static/media/password-avatar.8f4af650.svg";